import React from 'react';
import { Navigate } from 'react-router-dom';
import useAdmin from '../hooks/useAdmin';
import useAuth from '../hooks/useAuth';

const PublicRoute = ({children}) => {
    const isLoggedIn = useAuth();
    const isAdmin = useAdmin();


    return !isLoggedIn ? children : (!isAdmin?  <Navigate to='/lesson' /> : <Navigate to='/admin/dashboard'/>)
};

export default PublicRoute;